import React, {Component} from 'react';
import RaisedButton from 'material-ui/RaisedButton';
import Toggle from 'material-ui/Toggle'

const style = {
  margin: 12,
};

const contentStyle = {
  contentAlign: 'left',
  textAlign: 'left',
  display: 'inline-block',
};

export default class SettingsForm extends Component {
  render() {
    const {onNext, isInternalUse, onToggleInternalUse} = this.props;

    return (
      <form>
        <div>
          <h1>Ratzgiwatz Jugendprogramm Web-Anmeldung</h1>
          <h3>Einstellungen</h3>
          <div style={contentStyle}>
            <Toggle
              label="Verwendung während der Telefonanmeldung"
              toggled={isInternalUse}
              onToggle={onToggleInternalUse}
            />
          </div>
          <br />
          <RaisedButton
            style={style}
            label={`Zur Anmeldung`}
            onTouchTap={onNext}
          />
        </div>
      </form>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/settings/SettingsForm.jsx